module.exports = "@media (min-width: 992px){\r\n    .modal-lg {\r\n        max-width: 1320px;        \r\n    }\r\n}\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n.Background-Color .row:nth-child(odd) {\r\n    background-color: #f2f2f2;\r\n}\r\n.border-box{\r\n    border: 1px solid gray;\r\n    padding: 1px 15px;\r\n    margin-bottom: 8px;\r\n}\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-details/landdetails-grid/landdetails-grid.component.css
// module id = ./src/app/landprocurement/land-details/landdetails-grid/landdetails-grid.component.css
// module chunks = main